"use strict";
require('../users/CompanyUserService.js');
require('./AddGroupToLinkDirective.js');

CompanyUserRoleCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$q',
  'CompanyUserService'
];

function CompanyUserRoleCtrl(
  $scope,
  $stateParams,
  $q,
  CompanyUserService
) {

  $scope.templates = [{
    label: 'user-role.template-one',
    value: '1'
  }, {
    label: 'user-role.template-two',
    value: '2'
  }, {
    label: 'user-role.template-three',
    value: '5'
  }, {
    label: 'user-role.template-four',
    value: '6'
  }];

  $scope.addLink = function(userRole, isMenu) {
    if (isMenu) {
      userRole.menus.push({
        id: userRole.menus.length + 1,
        text: "",
        link: "#",
        parentId: null
      });
    } else {
      userRole.links.push({
        text: "",
        link: ""
      });
    }
  };

  $scope.removeLink = function(userRole, index, isMenu) {
    if (isMenu) {
      $scope.checkMenu(index, userRole).then(function(){
        userRole.menus.splice(index, 1);
      });

    } else {
      userRole.links.splice(index, 1);
    }
  };

  $scope.checkMenu = function(index, userRole) {
    var deferred = $q.defer();
    if (angular.isUndefined(userRole.menus[index].parentId) || userRole.menus[index].parentId === null) {
      userRole.menus = userRole.menus.map(function(r){
        if (r.parentId === userRole.menus[index].id) {
          r.parentId = null;
        }
        return r;
      });
    }
    deferred.resolve();
    return deferred.promise;
  };

  $scope.queryUsers = function(text, users) {
    return CompanyUserService.query({
      companyId: $stateParams.companyId,
      email: text,
      limit: 10
    }).$promise.then(function(resp) {
      return resp.filter(function(u) {
        return !users.some(function(user) {
          return user.id === u.id;
        });
      });
    });
  };
}

CompanyUserRoleCtrl.resolve = {
};

module.exports = CompanyUserRoleCtrl;

angular.module('dokiv')
  .controller('CompanyUserRoleCtrl', CompanyUserRoleCtrl);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/user-roles/CompanyUserRoleCtrl.js
// module id = 425
// module chunks = 0